import React from "react";
import { Box, IconButton, Typography, makeStyles } from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import EditIcon from "@material-ui/icons/Edit";
import { useTranslation } from "react-i18next";
import { getCountryLabel } from "util/countryDisplay";
import { formatDeparture } from "util/departureDisplay";

const useStyles = makeStyles({
  root: {
    color: "#fff",
    padding: "16px 20px",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 24,
  },
  title: {
    font: "normal normal normal 28px/32px Questrial",
    marginLeft: 8,
  },
  label: {
    color: "#ADADAD",
    fontSize: 12,
    marginBottom: 4,
  },
  value: {
    fontSize: 16,
    marginBottom: 20,
  },
  editBtn: {
    backgroundColor: "#6F9CEB",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#5a88d6",
    },
  },
});

export default function ZipcodesVisualizationDetail({
  selection,
  canEdit,
  seeAllSuppliers,
  onBack,
  onEdit,
}) {
  const classes = useStyles();
  const { t, i18n } = useTranslation("common");

  if (!selection) {
    return null;
  }

  const coordsLabel =
    selection.hasCoordinates && selection.latitude != null && selection.longitude != null
      ? `${selection.latitude}, ${selection.longitude}`
      : t("No geolocation");

  return (
    <Box className={classes.root}>
      <Box className={classes.header}>
        <Box display="flex" alignItems="center">
          <IconButton onClick={onBack} style={{ color: "#fff" }}>
            <ArrowBackIcon />
          </IconButton>
          <Typography className={classes.title}>{selection.zipcode}</Typography>
        </Box>
        {canEdit && (
          <IconButton className={classes.editBtn} onClick={onEdit} size="small">
            <EditIcon fontSize="small" />
          </IconButton>
        )}
      </Box>
      <Typography className={classes.label}>
        {selection.isMultiTour ? t("Tours") : t("Tour")}
      </Typography>
      {selection.isMultiTour ? (
        <Box component="ul" className={classes.value} style={{ margin: 0, paddingLeft: 20 }}>
          {(selection.tours || []).map((tour) => (
            <Box component="li" key={tour.id} mb={0.5}>
              {tour.tourName}
              {tour.departures?.length > 0 && ` (${tour.departures.map((d) => formatDeparture(d, t)).join(", ")})`}
            </Box>
          ))}
        </Box>
      ) : (
        <Typography className={classes.value}>
          {selection.tourName}
          {selection.departures?.length > 0 && ` (${selection.departures.map((d) => formatDeparture(d, t)).join(", ")})`}
        </Typography>
      )}
      <Typography className={classes.label}>{t("Zipcode")}</Typography>
      <Typography className={classes.value}>{selection.zipcode}</Typography>
      <Typography className={classes.label}>{t("Country")}</Typography>
      <Typography className={classes.value}>
        {getCountryLabel(selection.country, t, i18n)}
      </Typography>
      <Typography className={classes.label}>{t("Geolocation")}</Typography>
      <Typography className={classes.value}>{coordsLabel}</Typography>
      {seeAllSuppliers && (
        <>
          <Typography className={classes.label}>{t("Supplier")}</Typography>
          <Typography className={classes.value}>{selection.supplierLabel || "—"}</Typography>
        </>
      )}
    </Box>
  );
}
